module.exports = __webpack_public_path__ + "media/images/costumes/top/swiper-wafuku-3-c33c94a8debd0502d0b433d399bd13f9.jpg";